import { UserScreen } from "../components/UserScreen";

import { RotaPrivada } from './RotaPrivada'

export function ProfilePage() {
    return (
        <RotaPrivada>
            <UserScreen />
        </RotaPrivada>
    )
}